import { useQuery, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { InvoiceDocument } from '../generated-types';
import { getInvoiceArchive } from '../services/invoiceArchiveService';

const useInvoiceArchive = (options: Partial<QueryOptions<InvoiceDocument[]>> = {}): QueryResult<InvoiceDocument[]> =>
    useQuery({
        queryKey: ['invoiceArchive'],
        queryFn: getInvoiceArchive,
        staleTime: Infinity,
        ...options,
    });

export default useInvoiceArchive;
